import { object, array, number, boolean, string } from '@gogame/schemas';

import { filtersCollectionSchema } from './filtersSchema';
import { tableSettingsSchema } from './tableSettingsSchema';
import { metricsSchema } from './metricsSchema';
import { dimensionSchema } from './dimensionSchema';

export const screenSchema = object({
  filtersCollection: filtersCollectionSchema,
  tableSettings: tableSettingsSchema,
  metrics: metricsSchema,
  selectedIds: array(number()),
  searchQuery: string(),
  dimension: dimensionSchema,
  ready: boolean().default(false),
  advancedFilters: array(string()).default([]),
});

export const mapPresetToState = (presetData) =>
  screenSchema.cast(presetData, { parseConst: true, context: {} });
